module.exports = __webpack_public_path__ + "img/icon-6.dde56ff3.png";